import axios from 'axios';

/**
 * Step back to the wall when the tab is actually closing.
 *
 * pagehide used to start the ordinary drop-in mutation. A real tab close
 * aborts that request before it leaves the browser, so the student stays
 * on Engaged. fetch keepalive is sent during unload and is allowed to finish.
 */
export function postDropInStepBackKeepalive(
  slotId: string,
  etag: string | null | undefined,
): void {
  if (!slotId || typeof fetch !== 'function') return;
  const base = String(axios.defaults.baseURL ?? '').replace(/\/$/, '');
  if (!base) return;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const { common } = axios.defaults.headers;
  const authorization = common?.Authorization;
  if (typeof authorization === 'string' && authorization.length > 0) {
    headers.Authorization = authorization;
  }
  const tenant = common?.['X-Tenant-Id'];
  if (typeof tenant === 'string' && tenant.length > 0) {
    headers['X-Tenant-Id'] = tenant;
  }
  if (etag) headers['If-Match'] = etag;

  // The document is going away. There is nowhere to show a failure.
  fetch(`${base}/slots/${slotId}/drop-in`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ bookingId: null }),
    keepalive: true,
  }).catch(() => undefined);
}
